/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_ChangesInputs */

const id_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const ms_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan`)
};

const da_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringer`)
};

const de_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen`)
};

const en_us2_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

const es_es2_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const es_mx2_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const fil_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga pagbabago`)
};

const fr_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications`)
};

const it_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche`)
};

const hu_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változások`)
};

const nl_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingen`)
};

const no_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringer`)
};

const pl_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiany`)
};

const pt_br2_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações`)
};

const pt_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações`)
};

const ro_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificări`)
};

const fi_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutokset`)
};

const sv_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringar`)
};

const vi_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi`)
};

const tr_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklikler`)
};

const cs_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny`)
};

const bg_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промени`)
};

const ru_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения`)
};

const uk_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміни`)
};

const ar_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغييرات`)
};

const hi_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव`)
};

const th_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลง`)
};

const ja_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

const zh_cn2_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改`)
};

const zh_hant1_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變更`)
};

const ko_builds_comparison_changes = /** @type {(inputs: Builds_Comparison_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 사항`)
};

/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Builds_Comparison_ChangesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_changes = /** @type {((inputs?: Builds_Comparison_ChangesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_ChangesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_changes(inputs)
	if (locale === "ms") return ms_builds_comparison_changes(inputs)
	if (locale === "da") return da_builds_comparison_changes(inputs)
	if (locale === "de") return de_builds_comparison_changes(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_changes(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_changes(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_changes(inputs)
	if (locale === "fil") return fil_builds_comparison_changes(inputs)
	if (locale === "fr") return fr_builds_comparison_changes(inputs)
	if (locale === "it") return it_builds_comparison_changes(inputs)
	if (locale === "hu") return hu_builds_comparison_changes(inputs)
	if (locale === "nl") return nl_builds_comparison_changes(inputs)
	if (locale === "no") return no_builds_comparison_changes(inputs)
	if (locale === "pl") return pl_builds_comparison_changes(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_changes(inputs)
	if (locale === "pt") return pt_builds_comparison_changes(inputs)
	if (locale === "ro") return ro_builds_comparison_changes(inputs)
	if (locale === "fi") return fi_builds_comparison_changes(inputs)
	if (locale === "sv") return sv_builds_comparison_changes(inputs)
	if (locale === "vi") return vi_builds_comparison_changes(inputs)
	if (locale === "tr") return tr_builds_comparison_changes(inputs)
	if (locale === "cs") return cs_builds_comparison_changes(inputs)
	if (locale === "bg") return bg_builds_comparison_changes(inputs)
	if (locale === "ru") return ru_builds_comparison_changes(inputs)
	if (locale === "uk") return uk_builds_comparison_changes(inputs)
	if (locale === "ar") return ar_builds_comparison_changes(inputs)
	if (locale === "hi") return hi_builds_comparison_changes(inputs)
	if (locale === "th") return th_builds_comparison_changes(inputs)
	if (locale === "ja") return ja_builds_comparison_changes(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_changes(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_changes(inputs)
	return ko_builds_comparison_changes(inputs)
});
export { builds_comparison_changes as "builds.comparison.changes" }